import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Box, Button, Card, CardContent, CircularProgress, Stack, Typography } from '@mui/material';
import { ROUTES } from '../../config/routes';
import contratoVentaService, { ContratoKpis } from '../../services/contratoVentaService';
import { formatCurrency } from '../../utils/formatters';

const DashboardContratosWidget: React.FC = () => {
  const navigate = useNavigate();
  const [kpis, setKpis] = useState<ContratoKpis | null>(null);
  const [loading, setLoading] = useState(true);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await contratoVentaService.getKpis();
        if (!cancelled) setKpis(data);
      } catch {
        if (!cancelled) setHidden(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (hidden) return null;

  return (
    <Card sx={{ borderRadius: 2, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', height: '100%' }}>
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
          <Typography variant="h6" fontWeight={600}>
            Contratos de venta
          </Typography>
          <Button size="small" onClick={() => navigate(ROUTES.ventas.contratos.list)}>
            Ver
          </Button>
        </Stack>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
            <CircularProgress size={28} />
          </Box>
        ) : !kpis ? (
          <Alert severity="info">Sin datos de contratos</Alert>
        ) : (
          <Stack spacing={1}>
            <Typography variant="body2">
              Vigentes: <strong>{kpis.contratosVigentes}</strong>
            </Typography>
            <Typography variant="body2">
              Pendiente a facturar: <strong>{formatCurrency(kpis.pendienteFacturarPesos)}</strong>
            </Typography>
            <Typography variant="body2" color={kpis.periodosVencidos > 0 ? 'warning.main' : 'text.primary'}>
              Períodos vencidos: <strong>{kpis.periodosVencidos}</strong>
            </Typography>
            <Typography variant="body2" color={kpis.avancesSinFacturar > 0 ? 'warning.main' : 'text.primary'}>
              Avances sin facturar: <strong>{kpis.avancesSinFacturar}</strong>
            </Typography>
            {(kpis.periodosVencidos > 0 || kpis.avancesSinFacturar > 0) && (
              <Button
                size="small"
                variant="outlined"
                onClick={() => navigate(ROUTES.ventas.contratos.facturacion)}
              >
                Facturar pendientes
              </Button>
            )}
          </Stack>
        )}
      </CardContent>
    </Card>
  );
};

export default DashboardContratosWidget;
